module.exports = __webpack_public_path__ + "img/GHS.f10e2a47.svg";